import {ChangeDetectorRef, Component, ElementRef, Input, OnInit, ViewChild, ViewEncapsulation} from '@angular/core';
import {ComponentDefinition} from '@formbird/types';
import {ChangedDocumentService} from 'formbird-services';
import {FormbirdInjectorService} from '../../../../formbird-services/src/lib/services/injector/formbird-injector.service';
import {AbstractComponent} from '../../../../formbird-sc-shared/src/lib/components/abstract.component';
import {ComponentSetupService} from '../../../../formbird-sc-shared/src/lib/component-setup.service';
import {MatTooltip} from '@angular/material/tooltip';
import {MatFormField} from '@angular/material/form-field';


declare var $;
const logger = console;


interface QrCodeReaderComponentDefinition extends ComponentDefinition {
  approveMessage?: any;
  keyIds?: any;
}

@Component({
  templateUrl: './q-r-code-reader.component.html',
  styleUrls: ['./q-r-code-reader.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class QrCodeReaderComponent extends AbstractComponent<QrCodeReaderComponentDefinition> implements OnInit {

  @Input() floatLabel: any;
  @Input() docs: object = {};

  hideRequired: boolean;
  isRequired: boolean;
  user: any;
  showVideo: boolean;

  readerId: any;
  resultId: any;
  @ViewChild('video', {static: true}) videoElm: ElementRef;
  @ViewChild('canvas', {static: true}) canvasElm: ElementRef;
  videoStart = false;
  medias: MediaStreamConstraints = {
    audio: false,
    video: false,
  };

  modifiedFieldService: any;
  routerService: any;

  constructor(
    protected changedDocumentService: ChangedDocumentService,
    protected componentSetupService: ComponentSetupService,
    protected cdr: ChangeDetectorRef,
    protected formbirdInjectorService: FormbirdInjectorService
  ) {
    super(formbirdInjectorService, changedDocumentService, componentSetupService, cdr);
    this.modifiedFieldService = this.formbirdInjectorService.get('ModifiedFieldService');
    this.routerService = this.formbirdInjectorService.get('RouterService');
  }

  ngOnInit() {
    this.componentSetupService.setupStandardProperties(this);
    if ((this.document && this.document[this.componentDefinition.name])) {
      this.docs[this.fieldName] = this.document[this.componentDefinition.name];
    }

    if (!(typeof this.componentDefinition.mandatory === 'undefined' || this.componentDefinition.mandatory === null)) {
      this.isRequired = this.componentDefinition.mandatory;
    } else {
      this.isRequired = false;
    }
    this.hideRequired = !this.isRequired;
    this.componentDefinition = this.template.components[this.key];
    this.readerId = 'reader-' + this.fieldName;
    this.resultId = 'resultId-' + this.fieldName;
    this.showVideo = true;

  }


  scanQRCode() {
    this.toggleVideoMedia();
  }

  toggleVideoMedia() {
    this.showVideo = !this.showVideo;
    if (this.videoStart) {
      this.stopVideo();
    } else {
      this.startVideo();
    }
  }

  startVideo() {
    this.medias.video = {facingMode: {exact: 'environment'}};
    this.accessCamera(this.medias);
  }

  accessCamera(constraints) {
    navigator.mediaDevices.getUserMedia(constraints).then(
      (localStream: MediaStream) => {
        this.videoElm.nativeElement.srcObject = localStream;
        this.videoStart = true;
      }
    ).catch(
      error => {
        console.error(error);
        this.videoStart = false;
        this.medias.video = {facingMode: 'user'};
        this.accessCamera(this.medias);
      }
    );
  }

  stopVideo() {
    this.medias.video = false;
    this.videoElm.nativeElement.srcObject.getVideoTracks()[0].enabled = false;
    this.videoElm.nativeElement.srcObject.getVideoTracks()[0].stop();
    this.videoStart = false;
  }

  async checkImage() {
    const WIDTH = this.videoElm.nativeElement.clientWidth;
    const HEIGHT = this.videoElm.nativeElement.clientHeight;
    this.canvasElm.nativeElement.width = WIDTH;
    this.canvasElm.nativeElement.height = HEIGHT;

    const ctx = this.canvasElm.nativeElement.getContext('2d') as CanvasRenderingContext2D;

    ctx.drawImage(this.videoElm.nativeElement, 0, 0, WIDTH, HEIGHT);
    const imageData = ctx.getImageData(0, 0, WIDTH, HEIGHT);

    // Wait for dynamic import resolution
    const {default: jsQR} = await import(/* webpackChunkName: "jsqr" */ 'jsqr');
    const code = jsQR(imageData.data, imageData.width, imageData.height, {inversionAttempts: 'dontInvert'});

    if (code) {
      this.valueChanged(code.data);
      this.showVideo = !this.showVideo;
      this.stopVideo();
    }
  }

  qResultOpenLink() {
    this.routerService.navigateByUrl(this.document[this.fieldName]);
  }

  showToolTip(tooltip: MatTooltip, formFieldContainer: HTMLDivElement, labelContainer: HTMLElement) {
    return (labelContainer.offsetWidth <= formFieldContainer.scrollWidth);
  }

  toggleTooltip(tooltip: MatTooltip) {
    setTimeout(() => {
      tooltip.toggle();
    });
  }
}
